<template>
    <div>
        <section class="padding-vertical-content" id="paso1" ref="paso1">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">
                            {{ !event.reserva_instalaciones ? $t('partido.selecciona_entradas') : $t('partido.selecciona_reservas') }}
                        </h2>
                        <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5">
                            {{ !event.reserva_instalaciones ? $t('evento.elige_cantidad') : $t('evento.elige_cantidad_reservas') }}
                        </div>
                        <div class="row" id="seleccionar-zona">
                            <div class="col-12 col-lg-8">
                                <EntradasSinRecintoComponent
                                    :puede_seleccionar="puede_seleccionar"
                                    :entradas="entradas"
                                    :event="event"
                                    v-on:actualizar="actualizar"
                                    :iva="event.experiencia ? footer.iva_experiencia : footer.iva_partido"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="row">
                                    <div class="col-12">
                                        <DatosEntradasSinRecinto
                                            :entradas="entradas"
                                            :paso_activo="paso1_activo"
                                            :event="event"
                                            v-on:continuar="bloquearAsientos"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="pasoProductos" key="pasoProductos" id="pasoProductos"
                ref="pasoProductos">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ListadoProductosComponent :productos="productosListado" :desactivar="!pasoProductos_activo"/>
                        </div>
                    </div>
                </div>
                <CarritoEvento
                    :carrito_id="carrito_id"
                    :entradas="entradas"
                    :loading="loading"
                    :productos="productos"
                    :productosListado="productosListado"
                    :desactivar="!pasoProductos_activo"
                    @terminar="finalizarPasoProductos"
                    @cambiar-asiento="cambiarAsiento"
                    :containerRef="containerRefs.pasoProductos"
                />
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="paso2" id="paso2" key="paso2" class="padding-vertical-content lightgray-content">
                <div class="container">
                    <DatosCompradoresComponent
                        :datos_compradores="datos"
                        :generos="generos"
                        v-on:terminar="guardarDatos"
                        :entradas="entradas"
                        :solicitar_datos="event.solicitar_datos"
                        :loading="loading"
                        :desactivar="paso3 ? true : false"
                        :fields="event.fields" :errors="errors"
                        :reserva_instalaciones="event.reserva_instalaciones"
                        :event="event"
                        @cambiar-asiento="cambiarAsiento"
                    />

                    <div class="row">
                        <div v-if="loading" class="text-center col-12" style="margin-top: 100px; margin-bottom: 100px">
                            <LoaderComponent/>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="paso3" id="paso3" key="paso3" class="white-content padding-vertical-content">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                            <div class="mb-3 subtitle h3 light mb-lg-5">{{ $t('partido.revisa_datos') }}</div>
                        </div>
                        <div class="col-12 col-lg-8">
                            <template v-for="entrada in entradas">
                                <ul :key="entrada.id" v-if="entrada.unidades && entrada.unidades > 0"
                                    class="resumen d-md-flex justify-content-between">
                                    <li class="altcolor-content">
                                        <div class="m-0 text-bold oswald text-uppercase w-100">
                                            <span class="text-uppercase h4">1. </span> <span class="h4">{{ entrada.name }}</span>
                                            <template v-if="event.reserva_instalaciones">
                                                ({{ event.fecha_sesion }})
                                            </template>
                                        </div>
                                    </li>
                                    <li>
                                        <label class="h4">{{ $t('general.precio') }}</label>
                                        <div class="m-0 h4 padding-mobile">{{ entrada.price | formatear_precio }}</div>
                                    </li>

                                    <li class="altcolor-content">
                                        <label class="h4">{{ $t(!event.reserva_instalaciones ? 'evento.numero_entradas' : 'evento.numero_reservas') }}</label>
                                        <div class="m-0 h4 padding-mobile">{{ entrada.unidades }}</div>
                                    </li>
                                    <li>
                                        <label class="h4">{{ $t('evento.total') }}</label>
                                        <div v-if="entradas[0].price_management_interno" class="m-0 h4">{{ entrada.unidades * entrada.price | formatear_precio }}</div>
                                        <div v-else class="m-0 h4 padding-mobile">{{ entrada.unidades * entrada.price | formatear_precio }}</div>
                                    </li>
                                </ul>
                            </template>

                            <template v-if="voucher">
                                <ul class="resumen d-md-flex justify-content-between">
                                    <li class="altcolor-content">
                                        <div class="m-0 text-bold oswald text-uppercase w-100">{{ $t("evento.voucher") }}</div>
                                    </li>
                                    <li>
                                        <label>{{ $t("evento.code") }}</label>
                                        <div>{{ voucher.code }}</div>
                                    </li>

                                    <li>
                                        <label>{{ $t("evento.discount") }}</label>
                                        <div>
                                            {{ voucher.discount_percent != 0 ? voucher.discount_percent + "%" : voucher.discount_fixed + "€" }}
                                        </div>
                                    </li>
                                    <li>
                                        <label>{{ $t('evento.total') }}</label>
                                        <div class="m-0 h3">{{ -voucher_discounted_total | formatear_precio  }}</div>
                                    </li>
                                </ul>
                            </template>

                            <ResumenProductos v-if="productos && productos.length > 0" :productos="productos"/>

                        </div>
                        <template v-if="mostrarSeguro">
                            <div class="mb-4 col-12 col-lg-8">
                                <SeguroEntradasSinNumerarComponent
                                    :entradas="datos?.asientos?.filter(a => a.importe_seguro_entrada >= teatro.importe_minimo_seguro_entradas)"
                                    :seguros-seleccionados="segurosSeleccionados"
                                    :info-entradas-nominativas="info_entradas_nominativas"
                                    :loading="loadingSeguro || procesar_pago"
                                    @handleSeguro="handleSeguro"
                                />
                            </div>
                        </template>
                    </div>
                    <div class="col-12 col-lg-4">
                        <label>{{ $t('evento.total_pagar') }}</label>
                        <div class="price price-large gradient-color" v-if="entradas[0].price_management_interno || forceZeroManagement">{{ total - voucher_discounted_total + calcularTotalProductos() | formatear_precio }}</div>
                        <div class="resize price price-large gradient-color" v-else>{{ total_con_gd - voucher_discounted_total + calcularTotalProductos() | formatear_precio }}</div>
                    </div>
                    <div class="row">
                        <div class="mt-4 col-12 col-lg-8">
                            <CheckVoucherComponent class="mb-5" :event_id="event.id" :event_session_id="sesion_id" :cart_session_id="session_id" :loading="loading" @validated="setValidDiscountCode" />
                        </div>
                        <div class="col-12 col-lg-8">
                            <FormTerminos
                                :error="error"
                                @continuar="aceptarCondiciones"
                            />
                        </div>
                        <div class="col-12 col-lg-8">
                            <div class="mt-4 mt-lg-2">
                                <b-row>
                                    <b-col cols="12">
                                        <ResumenPrecioComponent :price="(total + calcularTotalProductosSinManagement()) - voucher_discounted_total " :price_management="forceZeroManagement ? 0 : total_gd" :price_management_interno="entradas[0].price_management_interno" :iva="event.experiencia ? footer.iva_experiencia : footer.iva_partido"/>
                                    </b-col>
                                    <b-col cols="12" class="mt-3">
                                        <Button
                                            id="terminar-compra"
                                            type="button"
                                            :label="(total == 0 || forceZeroManagement) ? $t('evento.descargar_entradas') : $t('evento.continue')"
                                            :disabled="procesar_precio_cero || procesar_pago || loadingSeguro || loading"
                                            custom-class="mb-3 text-uppercase"
                                            @click="terminar"
                                        />
                                        <Button
                                            id="atras"
                                            type="button"
                                            :label="$t('formularios.atras')"
                                            :disabled="procesar_precio_cero || procesar_pago || loadingSeguro || loading"
                                            custom-class="mb-3 text-uppercase tw:ml-2"
                                            @click="volver"
                                        />
                                    </b-col>
                                </b-row>
                                <p>
                                    <button :disabled="procesar_precio_cero" @click.prevent="terminar"
                                        class="button large-button effect-button">
                                        <span v-if="total == 0" class="text-uppercase">
                                            {{ $t("evento.descargar_entradas") }}
                                        </span>
                                        <span v-else class="text-uppercase">{{ $t("evento.continue") }}</span>
                                    </button>
                                </p>
                            </div>
                        </div>
                        <template v-if="form != null" >
                            <div id="formulario-compra" v-html="form" v-show="false"></div>
                        </template>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago"
                        id="pago">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                    <div class="mb-3 subtitle h3 light mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                    <PagoPaycometComponent
                                        ref="pago"
                                        tipo_venta="evento"
                                        :jet_id="jet_id"
                                        :session_id="session_id"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </transition>
            </section>
        </transition>
    </div>
</template>

<script>
    import EntradasSinRecintoComponent from '@/components/frontend/events/compra/EntradasSinRecintoComponent';
    import DatosEntradasSinRecinto from '@/components/frontend/events/compra/DatosEntradasSinRecinto';
    import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import CheckVoucherComponent from '@/components/frontend/events/compra/CheckVoucherComponent';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent';
    import ListadoProductosComponent from './components/productos/ListadoProductosComponent.vue';
    import CarritoEvento from './components/CarritoEvento.vue';
    import ResumenProductos from './components/productos/ResumenProductos.vue';
    import Button from '@/modules/ui/Button.vue';
    import SeguroEntradasSinNumerarComponent from '@/modules/front/events/SeguroEntradasSinNumerarComponent.vue';
    import { useEventoTracking } from '@/composables/front/analytics/useEventoTracking';
    import { buildUtmParams } from '@/composables/common/useTrackingParams';

    export default {
        props: ['event', 'sesion_id', 'tiempoTerminado'],
        data() {
            return {
                zonas: null,
                entradas: null,
                datos: {},
                formulario: null,
                session_id: null,
                carrito_id: null,
                terminos: false,
                newsletter: false,
                paso1_activo: true,
                pasoProductos: false,
                pasoProductos_activo: false,
                pasoProductos_loading: false,
                paso2: false,
                paso3: false,
                error: false,
                loading: false,
                puede_seleccionar: true,
                voucher: "",
                pixel_id: process.env.VUE_APP_PIXEL_ID,
                procesar_pago: false,
                procesar_precio_cero: false,
                jet_id: null,
                errors: null,
                envio_whatsapp: true,
                noTieneTelefono: false,
                isValidNumber: false,
                productos: [],
                productosListado: [],
                containerRefs: {
                    pasoProductos: null,
                },
                carritoHeights: {
                    pasoProductos: 0,
                },
                segurosSeleccionados: [],
                formularioConSeguro: null,
                loadingSeguro: false,
                info_entradas_nominativas: null,
                ga4PaymentInfoTracked: false
            }
        },
        created() {
            this.entradas = this.event.entradas;
            this.iniciarCompra();
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        },
        watch: {
            tiempoTerminado(tiempoTerminado) {
                if (tiempoTerminado) {
                    this.reset();
                }
            },
            pasoProductos(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        const container = this.$refs.pasoProductos;
                        if (container) {
                            this.containerRefs.pasoProductos = container;
                            const carrito = container.querySelector('.carrito-compras');
                            this.carritoHeights.pasoProductos = carrito ? carrito.offsetHeight : 0;
                        }
                    });
                } else {
                    this.containerRefs.pasoProductos = null;
                    this.carritoHeights.pasoProductos = 0;
                }
            }
        },
        computed: {
            form() {
                return this.formularioConSeguro ?? this.formulario;
            },
            mostrarSeguro() {
                return this.teatro.seguro_entradas_activo && this.datos?.tipoDocumentoSeleccionado?.type !== "OTROS";
            },
            url() {
                return window.location.href;
            },
            total_con_gd() {
                let total = 0;
                if(this.entradas != undefined) {
                    for(let e in this.entradas) {
                        if(this.entradas[e].unidades > 0) {
                            total = total + (this.entradas[e].total_price * this.entradas[e].unidades);
                        }
                    }
                }

                return total + this.totalSeguros;
            },
            total() {
                var total = 0;
                if(this.entradas != undefined) {
                    for(var e in this.entradas) {
                        if(this.entradas[e].unidades > 0) {
                            total = total + (this.entradas[e].price * this.entradas[e].unidades);
                        }
                    }
                }

                return total + this.totalSeguros;
            },
            total_gd() {
                var total = 0;
                for(var i in this.entradas) {
                    if(this.entradas[i].unidades > 0) {
                        var gd = parseFloat(this.entradas[i].price_management) * this.entradas[i].unidades;

                        total = total + gd;
                    }
                }

                if (this.productos && this.productos.length > 0) {
                    total += this.productos.reduce((total, producto) => {
                        const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                        return total + (priceManagement * producto.units);
                    }, 0);
                }

                return total;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            voucher_discounted_total() {
                if(!this.voucher) return 0;

                var total = 0;
                var voucher_units = this.voucher.units;

                for(var entrada of this.entradas) {
                    if(voucher_units <= 0) break;

                    for(var unit = 0; unit < entrada.unidades; unit++) {
                        if(voucher_units <= 0) break;
                        voucher_units--;

                        if(this.voucher.discount_percent > 0) {
                            total += (this.voucher.discount_percent / 100) * parseFloat(entrada.price);
                        } else {
                            total += parseFloat(this.voucher.discount_fixed);
                        }
                    }
                }

                return total;

            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            forceZeroManagement() {
                const teatroId = Number(this.teatro?.id);
                if (![1, 10, 791].includes(teatroId)) return false;
                return (this.total - this.voucher_discounted_total) <= 0;
            },
            generos() {
                return this.$store.getters.getGeneros;
            },
            totalSeguros() {
                return this.segurosSeleccionados
                    .filter(s => s.seguro)
                    .reduce((acc, s) => {
                        const entrada = this.datos?.asientos?.find(e => e.cart_item_id === s.cart_item_id);
                        return acc + (entrada?.importe_seguro_entrada || 0);
                    }, 0);
            },
            hayEntradasAseguradas() {
                return this.segurosSeleccionados.filter(s => s.seguro).length > 0;
            }
        },
        methods: {
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            async iniciarCompra() {
                this.$nextTick(() => {
                    this.$refs.paso1?.scrollIntoView({ behavior: 'smooth' });
                });
            },
            terminar() {
                if (this.terminos && !this.noTieneTelefono) {
                    if (!this.ga4PaymentInfoTracked) {
                        this.trackPaymentInfo();
                        this.ga4PaymentInfoTracked = true;
                    }

                    if (this.formulario) {
                        setTimeout(() => {
                            const form = document.querySelector('#formulario-compra form');
                            if (form) form.submit();
                        }, 1000);
                    } else if (this.forceZeroManagement || this.total == 0) {
                        // Teatros especiales con GG anulado o entrada a 0: descarga directa sin pago
                        this.procesar_precio_cero = true;
                        this.procesarCompraPrecioCero();
                    } else if (this.jet_id) {
                        this.procesar_pago = true;
                        this.$nextTick(() => {
                            this.scrollTo('#pago');
                        });
                    }
                } else {
                    this.error = true;
                }
            },
            bloquearAsientos() {
                this.loading = true;
                this.paso1_activo = false;
                this.puede_seleccionar = false;

                let params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    entradas: this.entradas
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                const fbp = this.$cookies.get("_fbp");
                const fbc = this.$cookies.get("_fbc");

                if (fbp && fbc){
                    params.fbp = fbp;
                    params.fbc = fbc;
                }

                const utmParams = buildUtmParams(this.$route.query);

                if (utmParams) {
                    Object.assign(params, utmParams);
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                        this.$router.go(this.$router.currentRoute);
                    } else {
                        this.carrito_id = res.data.cart_id;
                        if(this.event.tiene_productos) {
                            this.pasoProductos = true;
                            this.pasoProductos_activo = true;
                            this.$nextTick(() => {
                                this.scrollTo('#pasoProductos');
                            });
                        } else {
                            this.paso2 = true;
                            this.$nextTick(function() {
                                this.scrollTo('#paso2');
                            });
                        }

                        this.session_id = res.data.session_id;
                        sessionStorage.setItem('session_id', this.session_id);
                        this.loading = false;

                        const { trackBeginCheckout } = useEventoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });
                        const totalPrice = (this.entradas || [])
                            .filter(e => e.unidades && e.unidades > 0)
                            .reduce((sum, e) => sum + ((e.price || 0) * (e.unidades || 0)), 0);
                        const eventoResumen = {
                            evento_id: this.event?.id,
                            evento_name: this.event?.nombre || this.event?.name,
                            total_price: totalPrice,
                            entradas: this.entradas,
                            productos: this.productos || []
                        };
                        trackBeginCheckout(eventoResumen);
                    }
                }).catch(error => {
                    this.$toast.error('Entradas agotadas.');
                    this.$router.go(this.$router.currentRoute);
                    console.log(error);
                    this.loading = false;
                });
            },
            async finalizarPasoProductos() {
                this.loading = true;

                const tieneProductos = this.productosListado.length > 0 || (this.productos.length > 0 && this.productosListado.length > 0);

                if (!tieneProductos) {
                    this.pasoProductos_activo = false;
                    this.loading = false;
                    this.paso2 = true;
                    this.$nextTick(() => this.scrollTo('#paso2'));
                    return;
                }

                const transformedProductos = this.productosListado.map(product => ({
                    teatro_product_id: product.item.id,
                    event_id: this.$route.params.event_id,
                    event_session_id: this.$route.params.sesion_id,
                    units: product.units,
                }));

                if (this.productos.length > 0) {
                    const deleteParams = {
                        filters: {
                            tid: this.configuracion.hash_teatro,
                        },
                        cart_id: this.carrito_id,
                    };

                    try {
                        await this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos.delete'), deleteParams);
                    } catch (e) {
                        console.error(e);
                    }
                }

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    cart_id: this.carrito_id,
                    productos: transformedProductos,
                };

                try {
                    await this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos'), params);
                    this.pasoProductos_activo = false;
                    this.productosListadoCombinacion();
                    this.loading = false;
                    this.paso2 = true;
                    this.$nextTick(() => this.scrollTo('#paso2'));
                } catch (error) {
                    console.error('Error al añadir productos al carrito:', error);
                    this.loading = false;
                }
            },
            guardarDatos(info_entradas, datosCompradores) {
                this.loading = true;
                this.info_entradas_nominativas = info_entradas;

                if (datosCompradores) {
                    this.datos = datosCompradores;
                    this.datos.voucher = this.voucher;
                }

                this.datos.asientos = info_entradas ?? this.datos.asientos;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos,
                    session_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.datos = res.data.datos_compradores[0];
                    if (this.datos.telefono) {
                        this.isValidNumber = true;
                    }
                    this.paso3 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });

                }).catch(error => {
                    if (error.response.data.message == 'Campos requeridos') {
                        this.errors = error.response.data.errors;
                    } else {
                        this.$toast.error(error.response?.data?.message);
                    }
                }).finally(() => this.loading = false);
            },
            async volver() {
                if (this.hayEntradasAseguradas) {
                    await this.actualizarSeguros();
                }
                this.ga4PaymentInfoTracked = false;
                this.$nextTick(function() {
                    this.paso3 = false;
                    this.$scrollTo('#paso2', 100);
                });
            },
            async actualizarSeguros() {
                const aseguradas = this.segurosSeleccionados
                    .filter(s => s.seguro === true)
                    .map(s => ({
                        cart_item_id: s.cart_item_id,
                        seguro: false
                    }));

                if (aseguradas?.length > 0) {
                    try {
                        this.loading = true;

                        const params = {
                            session_id: this.session_id,
                            cart_items: aseguradas
                        };

                        await this.$store.dispatch(this.config.getVuexAlias('front.actualizar.seguro'), params).then(() => {
                            this.segurosSeleccionados = this.segurosSeleccionados.map(s => ({
                                ...s,
                                seguro: false
                            }));
                        });
                    } catch (error) {
                        this.$toast.error(error?.response?.data?.message || 'Error al desactivar los seguros');
                    } finally {
                        this.loading = false;
                    }
                }
            },
            actualizar(siguiente) {
                this.loading = true;
                this.$emit('actualizarEntradas');
                this.$nextTick(function() {
                    this.siguiente = siguiente;
                    this.loading = false;
                });
            },
            trackPaymentInfo() {
                try {
                    const { trackAddPaymentInfo } = useEventoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });

                    const totalPrice = (this.entradas || [])
                        .filter(e => e.unidades && e.unidades > 0)
                        .reduce((sum, e) => sum + ((e.price || 0) * (e.unidades || 0)), 0);
                    const eventoResumen = {
                        evento_id: this.event?.id,
                        evento_name: this.event?.nombre || this.event?.name,
                        total_price: totalPrice,
                        entradas: this.entradas,
                        productos: this.productos || []
                    };
                    trackAddPaymentInfo(eventoResumen);
                } catch (error) {
                    console.error('[GA4] add_payment_info failed:', error);
                }
            },
            async setValidDiscountCode(voucher) {
                this.datos.voucher = voucher;
                this.voucher = voucher;
                if (this.hayEntradasAseguradas) {
                    await this.actualizarSeguros();
                }
                this.guardarDatos();
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.datos.privacidad = privacidad;
                this.datos.condiciones = condiciones;
                this.datos.comunicaciones = comunicaciones;
                if (continuar == true) {
                    this.guardarTerminosCondiciones();
                    this.terminos = true;
                } else {
                    this.terminos = false;
                }
            },
            reset() {
                if (this.procesar_pago) {
                    this.$refs.pago.clearAllIntervals();
                }
                this.ga4PaymentInfoTracked = false;
                this.$emit('reset');
            },
            procesarCompraPrecioCero() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    carrito_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                    this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                }).catch(error => {
                    this.$router.push(`/compra/0/0`);
                }).finally(() => this.loading = false);
            },
            guardarTerminosCondiciones(){
                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    privacidad: this.datos.privacidad,
                    condiciones: this.datos.condiciones,
                    comunicaciones: this.datos.comunicaciones,
                    session_id: this.session_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('front.guardar.terminos.condiciones'), params).catch(error => {
                    this.$toast.error('Error al guardar los terminos y condiciones');
                });
            },
            cambiarAsiento(dummy = null, productos = false) {
                this.ga4PaymentInfoTracked = false;

                if (productos) {
                    this.paso1_activo = true;
                    this.puede_seleccionar = true;
                    this.pasoProductos = false;
                    this.pasoProductos_activo = false;
                    this.productos = [];
                    this.productosListado = [];
                    this.$nextTick(() => {
                        this.scrollTo('#paso1');
                    });
                } else {
                    this.datos = {};
                    this.paso2 = false;
                    if (this.event.tiene_productos) {
                        this.pasoProductos = true;
                        this.pasoProductos_activo = true;
                        this.$nextTick(() => {
                            this.scrollTo('#pasoProductos');
                        });
                    } else {
                        this.paso1_activo = true;
                        this.puede_seleccionar = true;
                        this.$nextTick(() => {
                            this.scrollTo('#paso1', 600);
                        });
                    }
                }
            },
            productosListadoCombinacion() {
                for (let index = 0; index < this.productosListado.length; index++) {
                    const product = this.productosListado[index];
                    if (this.productos.find(item => item.item.id === product.item.id)) {
                        this.productos.find(item => item.item.id === product.item.id).units += product.units;
                    } else {
                        this.productos.push(product);
                    }
                }

                this.productosListado = [];
            },
            calcularTotalProductos() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                    return acc + (producto.item.price * producto.units) + (priceManagement * producto.units);
                }, 0);
            },
            calcularTotalProductosSinManagement() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    return acc + (producto.item.price * producto.units);
                }, 0);
            },
            async handleSeguro({ cart_item_id, seguro }) {
                this.loadingSeguro = true;
                const index = this.segurosSeleccionados.findIndex(s => s.cart_item_id === cart_item_id);

                if (seguro) {
                    if (index === -1) {
                        this.segurosSeleccionados.push({ cart_item_id, seguro: true });
                    } else {
                        this.segurosSeleccionados[index].seguro = true;
                    }
                } else {
                    if (index !== -1) {
                        this.segurosSeleccionados[index].seguro = false;
                    }
                }

                const payload = {
                    session_id: this.session_id,
                    cart_items: this.segurosSeleccionados
                };

                try {
                    await this.$store.dispatch(this.config.getVuexAlias('front.actualizar.seguro'), payload).then(res => {
                        if (res.data.formulario) {
                            this.formularioConSeguro = res.data.formulario;
                        } else {
                            this.formularioConSeguro = null;
                        }
                    });
                } catch (error) {
                    this.$toast.error('Error al actualizar el seguro');
                } finally {
                    this.loadingSeguro = false;
                }
            }
        },
        components: {
            ResumenPrecioComponent,
            EntradasSinRecintoComponent,
            DatosEntradasSinRecinto,
            DatosCompradoresComponent,
            FormTerminos,
            CheckVoucherComponent,
            PagoPaycometComponent,
            ListadoProductosComponent,
            CarritoEvento,
            ResumenProductos,
            Button,
            SeguroEntradasSinNumerarComponent
        }
    }
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.resize {
    font-size: 3rem !important;
}

@media (max-width: 768px) {
    .padding-mobile {
        padding-bottom: 12px;
    }
}
</style>
